// extracted by mini-css-extract-plugin
module.exports = {"base":"_02712f2b3b--base--cJUPb"};